export default function() {
  const widgetName = 'cardWidgetJumpToVenue';
  const widgetOpts = cardWidgetJumpToVenueOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function(i) {
        const title = data.items[i].Title;
        const desc = data.items[i].Description;
        $(this).attr('data-title', title);
        $(this).attr('aria-label', title);
        $(this).addClass(desc);
      }); 

      $(`#${widgetName}`).prepend('<div class="jtv-title">Jump to a <span>Venue</span></div>');

      if ($('body').hasClass('homepage')) {
        $(`#${widgetName}`).appendTo('.section-tier-one');
      } else {
        $(`#${widgetName}`).appendTo('.afterContent');
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}